/**
 * File photoswipe.js
 *
 * Handles Photo Swipe.
 */

// eslint-disable-next-line import/no-unresolved
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// eslint-disable-next-line import/no-unresolved
import 'photoswipe/style.css';

const lightbox = new PhotoSwipeLightbox( {
	closeSVG: '<i class="fa-sharp fa-regular fa-close"></i>',
	zoomSVG: '<i class="fa-sharp fa-regular fa-search-plus"></i>',
	gallery: '.photoswipe-gallery',
	children: 'a',
	initialZoomLevel: 'contain',
	pswpModule: () => import( 'photoswipe' ),
} );
lightbox.init();

const projectLightbox = new PhotoSwipeLightbox( {
	closeSVG: '<i class="fa-sharp fa-regular fa-close"></i>',
	zoomSVG: '<i class="fa-sharp fa-regular fa-search-plus"></i>',
	gallery: 'article.project',
	children: 'figure a',
	initialZoomLevel: 'contain',
	pswpModule: () => import( 'photoswipe' ),
} );
projectLightbox.init();
